module.exports = __webpack_public_path__ + "img/file__icon-word.b6c08345.svg";